import { render, staticRenderFns } from "./BasicRequirement.vue?vue&type=template&id=d4c73b28&scoped=true&"
import script from "./BasicRequirement.vue?vue&type=script&lang=js&"
export * from "./BasicRequirement.vue?vue&type=script&lang=js&"
import style0 from "./BasicRequirement.vue?vue&type=style&index=0&id=d4c73b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c73b28",
  null
  
)

export default component.exports